export const isUserAssignedToCustomer = (users: any[] = [], userId: any) => users.some(user => user.user_id === userId)
